import React from "react";
import { Box } from "@mui/material";

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
// Removed navigation CSS import as it's no longer needed

// Assets
import LinesDecor from "./LinesDecor";

// Components
import StandardSlide from "./slides/StandardSlide";
import CenteredSlide from "./slides/CenteredSlide";
import InvertedSlide from "./slides/InvertedSlide";

const HeroCarousel = ({ slides = [], defaultBg }) => {

  if (!slides || slides.length === 0) return null;

  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      <style>
        {`
        .swiper-pagination {
            z-index: 1000 !important;
            bottom: 30px !important; 
              @media (max-width: 675px) {
              bottom: 120px !important; 
            }
          }
          .swiper-pagination-bullet {
            width: 12px;
            height: 12px;
            background-color: #ffffff;
            opacity: 0.5;
            margin: 0 6px !important;
          }
          .swiper-pagination-bullet-active {
            opacity: 1;
            background-color: #00b5e2;
          }
          @media (max-width: 1200px) {
            .swiper-pagination-bullet {
              background-color: #002349;
              opacity: 0.7;
            }
            .swiper-pagination-bullet-active {
              background-color: #00b5e2;
              opacity: 1;
            }
            .swiper {
              padding-bottom: 2rem !important;
            }
          }
        `}
      </style>
      <Swiper
        // Navigation module removed from here
        modules={[Pagination, Autoplay]} 
        breakpoints={{
          1200: {}
        }}
        speed={1500}
        loop={true}
        autoplay={{ 
            delay: 6000, 
            disableOnInteraction: false, 
            pauseOnMouseEnter: false, 
            pauseOnTouch: true 
        }}
        navigation={false} // Explicitly set to false
        pagination={{ clickable: true }}
        style={{ width: "100%", height: "100%" }}
      >
        {slides.map((item, index) => {
          const isCentered = item.layout === "centered";
          const isPriority = index === 0; 
          
          return (
            <SwiperSlide key={index}>
              {isCentered ? (
                <CenteredSlide item={item} defaultBg={defaultBg} priority={isPriority} />
              ) : item.layout === "inverted_right" ? (
                <InvertedSlide item={item} defaultBg={defaultBg} priority={isPriority} />
              ) : (
                <StandardSlide item={item} defaultBg={defaultBg} priority={isPriority} />
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>

       <Box sx={{ 
          "@media (max-width: 675px)": { 
            marginTop: "-100px", 
          } 
        }}>
          <LinesDecor
            greenMt={{ xl: -6.5, lg: -5.5, md: -5.5, sm: -3, xs: 1 }}
            blueMt={{ xl: -1, lg: 1, md: 0, sm: 1.9, xs: 3 }}
          />
        </Box>
    </Box>
  );
};

export default HeroCarousel;